import { render, staticRenderFns } from "./bimTextAccent.vue?vue&type=template&id=5a5d6fc5&scoped=true&lang=html&"
import script from "./bimTextAccent.vue?vue&type=script&lang=js&"
export * from "./bimTextAccent.vue?vue&type=script&lang=js&"
import style0 from "./bimTextAccent.vue?vue&type=style&index=0&id=5a5d6fc5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d6fc5",
  null
  
)

export default component.exports